import { AppBar, Dialog, IconButton, Paper, Slide, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import React from 'react';
import { withLoading } from '../../contexts/LoadingContext';
import RelatorioBeneficiariosService from '../../services/RelatorioBeneficiariosService';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import PrintComponentRelatorioBeneficiarios from './PrintComponentRelatorioBeneficiarios';

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  toolbar: {
    display: 'flex',
    backgroundColor: '#5c6bc0',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    padding: theme.spacing.unit * 2,
  },
  flex: {
    flex: 1,
  },
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 15,
    paddingBottom: theme.spacing.unit * 15,
    margin: theme.spacing.unit * 2,
  },
});
function Transition (props) {
  return <Slide direction='left' {...props} />;
}
class FullScreenRelatorioBeneficiarios extends React.Component {
  relatorioBeneficiariosService = new RelatorioBeneficiariosService();
  state = {
    beneficiarios: [],
    loading: true,
  }
  componentDidMount () {
    this.props.showLoading('Aguarde, essa consulta pode demorar um pouco..');
    this.consultarBeneficiariosJson(this.props.filtro);
    this.props.hideLoading();
  }
  consultarBeneficiariosJson = async (filtro) => {
    const beneficiariosJson = await this.relatorioBeneficiariosService.consultarBeneficiariosJson(filtro);
    this.setState({ beneficiarios: beneficiariosJson, loading: false });
  }
    render () {
    const { classes, open, handleClose } = this.props;
    return (
      <div>
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          scroll='paper'
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Paper square elevation={0} className={classes.toolbar} onClick={handleClose} color='inherit'>
              <IconButton color='inherit' onClick={handleClose} aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='title' color='inherit' className={classes.flex}>
                {'Relatório de Benficiários - ' + this.props.tituloConsulta}
              </Typography>
            </Paper>
          </AppBar>
          {this.state.loading ? <LinearProgressBlockScreen />
            : <PrintComponentRelatorioBeneficiarios
              beneficiarios={this.state.beneficiarios}
              tituloConsulta={this.props.tituloConsulta} />}
        </Dialog>
      </div>
    );
  }
}

export default withLoading(withStyles(styles)(FullScreenRelatorioBeneficiarios));
